<template>
  <main>
    <vue-headful
      title="リヨン補習授業校 L'Ecole Complémentaire pour l'Enseignement du Japonais à Lyon"
      description="リヨン補習授業校では、リヨン及びその周辺在住の日本・日仏子女を対象に、日本の学習指導要領に準拠した国語および算数の補習授業を行なっています。"
      url="https://adlcj.fr/ecole"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
      type="article"
    />
    <section class="title">
      <div class="title-wrapper">
        <h1>{{ $t("title.ecole") }}</h1>
      </div>
      <div>
        <p>{{ $t("home.h1") }}</p>
      </div>
    </section>
    <div v-if="this.$i18n.locale === 'ja'">
      <EcoleJA />
    </div>
    <div v-if="this.$i18n.locale === 'fr'">
      <EcoleFR />
    </div>
  </main>
</template>

<script>
import EcoleJA from "../components/EcoleJA.vue";
import EcoleFR from "../components/EcoleFR.vue";
export default {
  components: {
    EcoleJA,
    EcoleFR,
  },
};
</script>
<style lang="scss" scoped>

</style>